import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import PostLoginRoutes from "./postLoginRoutes";
import PreLoginRoutes from "./preLoginRoutes";

const CommunityLoginRoutes = () => {
  const [cookies, setCookie] = useCookies(["authToken"]);

  function onChange(val) {
    setCookie("authToken", val.token, { path: "/" });
    setCookie("userID", val.userId, { path: "/" });
  }

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    console.log("cookie check: ", cookies);
    if (cookies && cookies.authToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, [cookies, cookies.authToken]);

  return (
    <>
      {isAuthenticated ? (
        <PostLoginRoutes onChange={onChange} />
      ) : (
        <PreLoginRoutes onChange={onChange} />
      )}
    </>
  );
};

export default CommunityLoginRoutes;
